<template>
	<app-page>
		<app-heading :title="isNew ? 'New Crawler' : crawler.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'market-airbnb-crawlers' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="crawler.name"
					required
					:errors="errors.name"
				/>
				<input-select
					label="City"
					:items="cities"
					v-model="crawler.market_city"
					required
					:errors="errors.market_city"
				/>
				<input-text
					label="Neighborhood"
					v-model="crawler.neighborhood"
					required
					:errors="errors.neighborhood"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.crawler = await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('airbnbcrawlers')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}

		this.cities = await this.$ravello.graphql('cities')
			.parent(this.$ravello.graphql('market', this.marketId))
			.datasource()
			.sort('name')
			.query()

		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			crawler: {
				name: '',
				market_city: null,
				neighborhood: '',
			},
			cities: [],
			errors: {},
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		id() {
			return this.$route.params.crawler
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			const request = this.$ravello.request()
				.v(2)
				.to('markets')
				.to(this.marketId)
				.to('airbnbcrawlers')

			const payload = {
				name: this.crawler.name,
				market_city: this.crawler.market_city,
				neighborhood: this.crawler.neighborhood,
			}

			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request
						.to(this.id)
						.update(payload)
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Crawler successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'market-airbnb-crawlers' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
